<template>
    <!-- <section class="section-hero  cto-founder courses-hero"> -->
    <section class="section-hero" style="padding-bottom: 0.5rem;">
      <div class="hero container">
        <div class="hero-content">
            <h1 class="heading-primary">{{$t('Portfolio Management')}}</h1>
            
                 <div class="founder-avatar">
                        <img :src="course.iconUrl"  style="width:45rem;border-radius:16px;"/>
                        
                    </div>
                <div class="section-header">
                   
                    <h2 class="heading-secondary">
                      <!-- {{getShortDesc(course)}} -->
                
               
                    </h2>
                   
                </div>

                 <section class="home-education">
                  <div class="container section-value-props section-education hidden">
                    <div class="section-header">
                      
                      
                      <Card>
                         <!-- <template #header>
                          <img alt="user header" src="/assets/qtrade-logoon-white.jpeg" style="max-width:25rem;"/> 
                          </template> -->
                        <template #title>
                            {{$t('Course Overview')}}
                        </template>
                        <template #content>
                          <div class="course-desc">
                          <p class="value-description value-description2">
                             Building a goal achieving portfolio is not something that happens by accident or by making a few lucky stock picks.  <br>
                             Achieving your goals, whether it's retirement, buying a house, or investing for your children's education takes planning and execution.
                          </p>
                          </div>
                          <div class="course-desc">
                          <p class="value-description value-description2">
                             In this course, you learn how to quantify your goals, develop a plan for achieving them, monitor your progress and course correct when necessary.  
                             You'll learn how to transition your portfolio from the accumulation phase of the portfolio, to the harvest phase.
                             <br>This course goes deeper into some subjects discussed in the Foundation course including compound growth, risk and return, diversification, and investment goals.  
                          </p>
                          <p class="value-description value-description2">New material includes portfolio rebalancing and tilting, fees and taxes, and investment accounts.  
                             Included in the course are powerful tools like Portfolio Planner, Goal Mapping, Inflation Adjusted Target Date Goals, Adjusting Retirement Portfolio for Tax, a Diversification Matrix and an Allocation Matrix.
                             What's extra special about this course is that you get to use these tools as you build your own portfolio using our trading simulator, research tools, and portfolio module.
                             Note: in this course, you use ETFs to build the portfolio, however, the same principles apply no matter what it holds.
                          </p>
                          <p class="value-description value-description2">
                             This course is divided into nine modules, explained below.  As you go through the course, you will be periodically tested on the material.  
                             When you answer correctly you'll earn our platform currency called "Playdough".  You'll use your Playdough to build a portfolio on INVRS.
                  
                          </p>
                          </div>
                          <div class="course-outline">
                            <p class="value-description ">Here's brief outline of what's covered in the course:</p>
                          <p class="value-description">
                              <ul class="course-outline-list value-description">
                                <li>Module 1: Compound Growth - Compound growth is your portfolio's fuel.  In this course, we take a deep dive into what compound growth is and into understanding the tools you have at your disposal to improve your fuel's ability to propel your vehicle.</li>
                                <li>Module 2: Risk and Return - Risk and return are two sides of the same coin, you do not get one without the other.  In this module we learn where return comes from, what risk is, and how it affects return.  To make compound growth work as productively as possible for us, we need to understand the dance between the two.</li>
                                <li>Module 3: Diversification - Diversification is a concept very closely tied to risk and return.  In fact, diversification acts as an emulsifier between risk and return, the ingredient that causes two unblendable  substances to merge.  We introduce you to the traditional theory about diversification, as well as more modern thinking on the subject.</li>
                                <li>Module 4: Portfolio Rebalancing and Tilting - Portfolio rebalancing is like the icing on the cake, a cake just isn't a cake without it.  Portfolio tilting is like making rosettes for the cake, a specialized skill definitely cool to add in, but not vital.</li>
                                <li>Module 5: Understanding Your Investment Goals - Once you have the building blocks under your belt, it's time to start making the course personal - what are your goals and how do you chart a course to achieving them?  What is your own risk profile?  How does risk-tolerance change over time?  These are some of the questions we look at. </li>
                                <li>Module 6: Fees, Taxes and Accounts - In this module, you learn where fees are incurred and how different forms of investment income is taxed.  Fees and taxes impact your rate of compound growth, so it is important to reduce them.  Fortunately, there are a number of investment account options, and you can select the one most efficacious to achieving your goal. </li>
                                <li>Module 7: Portfolio Framework I - The portfolio framework modules are the apex of the course where you get into the nuts and bolts of building a portfolio.  The two modules are complementary - they each give different information, but the goal is the same.  They provide two different views of building a portfolio. </li>
                                <li>Module 8: Portfolio Framework II - This module is the where the rubber meets the road, the number cruncher.  We figure out what it takes to get to goal as well as how to modify and how to monitor your progress.</li>
                                <li>Module 9: Portfolio Review - You've built a portfolio with the Playdough you earned testing your knowledge.  What exactly did you build and how did you build it?  This module gives you an overview of what you did, including the purchase cadence, how it was diversified, and a tool to use for more complex diversification challenges.</li>
                              </ul>

                          </p>
                          </div>
                          
                          
                          
                         



                          <!-- <div  class="course-vid-container">
                            <div class="video-text">{{ $t('Watch the video to get a more detailed overview of the course.')}}</div>
                          
                            <video class="course-vid" controls :poster="course.poster">
                                <source
                                    :src="course.video"
                                    type="video/mp4" />
                            </video>  
                            
                          </div> -->
                          <br>
                          <div class="pricing-header" >
                            <div class="course-pricing-cont">
                              <span class="course-price-label">{{$t('Price')}}:</span>
                              <div class="course-pricing">
                                <span class="course-price">{{course.cdnPrice}} CAD</span>
                               
                                
                              
                              </div>
                            </div>
                           
                            
                            
                          </div>
                           <div class="pricing-header" >
                             <div class="course-pricing-cont">
                              <div class="course-pricing">
                              <span>(Free for <a href="/pricing">Premium Plus subscribers</a>!)</span>
                              </div>
                            </div>
                            
                            
                          </div>
                           <a class="cta btn"   @click="goToSignup()" >{{$t('Sign Up')}}</a>
                           <br><br>
                          <div class="section-header">
                            <template v-if="i18nService.currentLocale == 'fr'">
                                <p class="signup-free value-description"><a style="cursor:pointer;" @click="goToSignup()">L'inscription est gratuite</a> (aucune carte de crédit requise). Une fois que vous avez un compte, vous pouvez prévisualiser ou acheter n'importe lequel de nos cours.</p>
                              </template>
                                
                              <template v-else>
                              <p class="signup-free value-description">It's free to <a style="cursor:pointer;" @click="goToSignup()">signup for an account</a> (no cc required). </p>
                              <p class="signup-free value-description">Once you have an account you can then purchase this course.</p>
                              <p class="signup-free value-description"><b>OR</b></p>
                               <p class="signup-free value-description">Purchase a <a href="/pricing">Premium Plus subscription</a> and get access to <b>all</b> of our <a href="/courses">courses</a> <br>and unlimited access to all our research tools and data.</p>
                              </template>
                          </div>
                        </template>
                       </Card>
                    </div>
                    
                    
                  </div>
                </section>
                
                
              
            
            
            
        </div>
      </div>
    </section>
    
  </template>
  
  <script>
import { SIGNUP_URL, QTRADE_REF_ON } from "../config.js";
//import DataView from "primevue/dataview";
import Card from "primevue/card";
//import Button from "primevue/button";


//import CourseInfoModal from '../components/education/CourseInfoModal.vue';
import i18nService from '../i18n.js';

  export default {
    name: "PortfolioManagement",

    components: {
       // Avatar
      // DataView,
       //CourseInfoModal,
       Card,
      // Button,
    
    },
    head() {
      return {
        title: "INVRS - Portfolio Management",
        meta:[
          { 
            name: "description",
            content: 'Learn how to effectively manage your portfolio in this hands-on practical course.'
          },
          { 
            name: "twitter:title",
            content: 'INVRS - Portfolio Management'
          },
          { 
            name: "twitter:description",
            content: 'Learn how to effectively manage your portfolio in this hands-on practical course.'
          },
          { 
            name: "og:title",
            content: 'INVRS - Portfolio Management'
          },
          { 
            name: "og:description",
            content: 'Learn how to effectively manage your portfolio in this hands-on practical course.'
          },
        ]
      }
    },

    data() {
      return {
         i18nService,
        heroSection: "",
        heroContent: "",
        ceoFounder: "",
        ctoFounder: "",
        ceoFounderImagePath: "../../assets/ceo-founder.jpg",
        obsOptionsHero: {
          root: null,
          threshold: 0.1,
        },
        course:
          { 
            name: this.$t("Portfolio Management"), 
            shortDescription: {
              en: `Managing your portfolio to meet your goals takes knowledge, planning and execution, but it doesn't have to take a lot of time and effort.  Learn how to effectively manage your portfolio in this hands-on practical course.`, 
              fr: "La gestion de votre portefeuille pour atteindre vos objectifs nécessite des connaissances, une planification et une exécution rigoureuses, mais cela ne doit pas nécessairement demander beaucoup de temps et d'efforts.  Apprenez à gérer efficacement votre portefeuille dans ce cours pratique."
            },
            description: {
              en:`Building a goal achieving portfolio is not something that happens by accident or by making a few lucky stock picks.  Achieving your goals, whether it's retirement, buying a house, or investing for your children's education takes planning and execution.<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;In this course, you learn how to quantify your goals, develop a plan for achieving them, monitor your progress and course correct when necessary.  You'll learn how to transition your portfolio from the accumulation phase of the portfolio, to the harvest phase.
This course goes deeper into some subjects discussed in the Foundation course including compound growth, risk and return, diversification, and investment goals.  New material includes portfolio rebalancing and tilting, fees and taxes, and investment accounts.<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Included in the course are powerful tools like Portfolio Planner, Goal Mapping, Inflation Adjusted Target Date Goals, Adjusting Retirement Portfolio for Tax, a Diversification Matrix and an Allocation Matrix. <br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; What's extra special about this course is that you get to use these tools as you build your own portfolio using our trading simulator, research tools, and portfolio module.
Note: in this course, you use ETFs to build the portfolio, however, the same principles apply no matter what it holds.`,
              fr: `Construire un portefeuille qui vous permettra d'atteindre vos objectifs n'est pas le fruit du hasard ou de quelques choix judicieux.  Que vous souhaitiez prendre votre retraite, acheter une maison ou investir dans les études de vos enfants, vous devez planifier et agir pour atteindre vos objectifs.
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dans ce cours, vous apprendrez à quantifier vos objectifs, à élaborer un plan pour les atteindre, à suivre vos progrès et à corriger le tir si nécessaire.  Vous apprendrez comment faire passer votre portefeuille de la phase d'accumulation à la phase de récolte.
Ce cours approfondit certains sujets abordés dans le cours « Fondamentaux », notamment la croissance composée, le risque et le rendement, la diversification et les objectifs d'investissement.  Les nouveaux thèmes abordés comprennent le rééquilibrage et l'orientation du portefeuille, les frais et les taxes, ainsi que les comptes d'investissement. <br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Le cours comprend des outils puissants tels que le planificateur de portefeuille, la cartographie des objectifs, les objectifs à date cible ajustés en fonction de l'inflation, l'ajustement du portefeuille de retraite en fonction de la fiscalité, une matrice de diversification et une matrice d'allocation. <br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ce qui rend ce cours vraiment unique, c'est que vous pouvez utiliser ces outils pour créer votre propre portefeuille à l'aide de notre simulateur de trading, de nos outils de recherche et de notre module de portefeuille.
Remarque : dans ce cours, vous utilisez des ETF pour créer votre portefeuille, mais les mêmes principes s'appliquent quel que soit son contenu.`
            },
            iconUrl: "/assets/port-management-300x200.png",
            
            cdnPrice: "$149.95",
            cdnDiscPrice: "$99.95",
            signupCode: 'build',
            langs: ['eng']
          },
           

       

       
       

        
      };
    },
    mounted() {
     console.log("current locale "+ i18nService.currentLocale)
    },
    methods: {

      isQTradeOn() {
        return QTRADE_REF_ON;
      },

      openCourseInfo(course) {
        this.$refs.courseInfoModal.open(course);
      },

      revealFounders() {
        //this.ceoFounder.classList.remove("hidden-founder");
        this.ctoFounder.classList.remove("hidden-founder");
      },
      revealHero() {
        this.revealFounders();
      },
      goToSignup() {
        //evt.preventDefault();
        window.location.href = SIGNUP_URL+"?courseCode="+this.course.signupCode;
       

        
      },
      getShortDesc(course){
        return course.shortDescription[i18nService.currentLocale];
      }
    },
  };
  </script>
  
  <style scoped>

    .value-description2{
      text-indent: 2rem;
    }

    .course-desc{
       margin-top: 1rem;
      margin-left:auto;
      margin-right:auto;
      text-align: left;
    }

    .course-outline{
      margin-top: 1rem;
      margin-left:auto;
      margin-right:auto;
      text-align: left;
    }

    .course-outline-list{
      padding-inline-start: revert;
    }

    .video-text{
      margin: 1rem auto 1rem auto;
      font-size: 1.8rem;
  }
.course-vid {
    width: 100%; 
}
.course-vid-container{
    text-align: center;
    width: 100%;
    display:flex;
      flex-direction: column;
      margin-top:5px;
      /*max-width: 30rem;*/
      align-items: baseline;
      align-self: flex-end;
      justify-content: end;

}
    .course-line{
      
    }

    .course-div{
      /*min-width:20rem;*/
    }
    ::v-deep(.emph){
      text-decoration: underline;
    }
    ::v-deep(.p-card .p-card-title){
      font-size: 2rem;
    }

    ::v-deep(.p-card-content){
      font-size: 2rem;
    }

    .course-info{
      display:flex;
      flex-direction:column;
      height:100%;
      min-height:100%;
      padding:5px;
    }
    .course-desc-cont{
      flex-grow: 1;
    }
    .course-box{
      display:flex;
      height:100%;
      cursor: pointer;
      flex-direction:row;
    }

    .course-img {
      max-width: 25rem;
      max-height: 25rem;
      margin-top: 1rem;
    }
    .course-price-label{
      font-size: 1.8rem;
      margin-right:auto;
    }

    .course-price{
      font-size: 1.8rem;
     
    }
    .course-pricing{
      display:flex;
      flex-direction: column;
      
      margin-left:5px;
      align-items: end;
    }
    .course-pricing-cont{
      display:flex;
      flex-direction: row;
      
      
      align-items: end;
      
    }

     .pricing-header{
      display:flex;
      flex-direction: row;
      margin-top:5px;
      /*max-width: 30rem;*/
      align-items: baseline;
      align-self: flex-end;
      justify-content: center;
    }

  .more-info{
    cursor:pointer;
    color:#33cc99;
    font-size: 1.2rem;
  }

  a.cta{
    padding: .8rem 1.3rem;
    align-self: center;
    margin-left:auto;
    font-size: 1.5rem;
    margin-top: 1rem;
  }

    .custom-text {
      padding-bottom:5rem;
    }
    .custom-section{
      align-items: center;
    }
    .custom-course-img{
      max-width:45rem;
    }
    .value-description{
      margin-bottom: 0;
    }

    .value-description {
    font-size: 1.5rem;
    line-height: 2.6rem;
  }

    .heading-course-cat {
      font-size: 3.2rem;
      color: #333;
      margin-bottom: 2.8rem;
      line-height: 1.1;
    }

   .courses-header{
      flex-direction: column;
   }

  .grid--2-cols {
      grid-template-columns: repeat(2, 1fr);
  }

  .key-points{
    margin-top:2rem;
  }

  .section-hero {
    position: relative;
    padding: 12.8rem 0 9.6rem 0;
    
  }
  
  .hero-content {
    max-width: 130rem;
    margin: 0 auto;
    padding: 0 3.6rem;
  }

  .heading-primary {
    margin-bottom: 3.8rem;
  }

  .hidden-founder {
    opacity: 0;
  }
  .hidden-content {
    transform: translateX(-9.6rem);
    opacity: 0;
  }
  .hidden-founder.ceo-founder {
    transform: translateX(-9.6rem);
  }

  .main-section {
    display: flex;
    align-items: flex-start;
    margin-bottom: 5rem;
    transition: all 0.6s ease-in;
    padding-left: 11rem;
  }

  .hero-founder {
    display: flex;
    align-items: center;
    margin-bottom: 3rem;
    margin-top: 3rem;
    transition: all 0.6s ease-in;
  }
  .hero-founder:last-of-type() {
    margin-bottom: 0;
  }

  .founder-heading {
    color: #32364e;
    font-size: 2.5rem;
  }

  .founder-avatar {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .founder-avatar .p-avatar {
    width: 18rem;
    height: 18rem;
    border: 3px solid #32364e;
  }

  .main-side {
    padding: 2rem;
    
    line-height: 1.6;
    
    max-width: 100rem;
    font-size:6rem;
    margin-left:3rem;
   
  }

  .section-header {
    text-align: center;
  }

  .founder-description {
    padding: 2rem;
    border-radius: 25px;
    line-height: 1.6;
    color: #333;
    max-width: 100rem;
    background: #fff;
    box-shadow: 0 0 2.4rem hsl(231deg 22% 25% / 20%);
  }

  .ceo-founder .founder-avatar {
    /*margin-right: 6rem;*/
  }
  
  .hidden-founder.cto-founder {
    transform: translateX(9.6rem);
  }

  .cto-founder {
    flex-direction: row-reverse;
  }
  
  .cto-founder .founder-avatar {
    margin-left: 6rem;
  }

   .heading-primary {
      font-size: 4rem;
      text-align: center;
    }

  .heading-secondary {
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  .signup-free{
   
    margin-bottom: 1rem;
  }

button {
  font-family: inherit;
  cursor: pointer;
  font-weight: 500;
  color: #fff;
  transition: all 0.2s;
  padding: 10px 20px;
  border-radius: 0.8rem;
  background-image: linear-gradient(
    to right,
    rgb(105, 59, 245, 1),
    rgb(105, 59, 245, 0.85),
    rgb(105, 59, 245, 0.7)
  );
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  font-size: 2rem;
  max-width: fit-content;
}

button:hover {
  box-shadow: 0 0.4rem 3.2rem rgb(105, 59, 245, 0.6);
  transform: scale(1.05);
}

button > svg {
  width: 3.6rem;
  margin-left: 1rem;
  transition: transform 0.3s ease-in-out;
  font-weight: 700;
}

button:hover svg {
  transform: translateX(5px);
}

button:active {
  transform: scale(0.95);
}



  /* **************************** */
  /* BELOW 1360px (Small desktop/laptop) */
  /* **************************** */
  @media (max-width: 85em) {
    .hero-content {
        max-width: 150rem;
    }
  
    .heading-primary {
      font-size: 4rem;
    }

    .founder-description {
        max-width: 75rem;
    }

    .main-side {
      max-width: 75rem;
    }
  }
  
  /* **************************** */
  /* BELOW 976px (landscape tablets) */
  /* **************************** */
  @media (max-width: 61em) {
    .hero-content {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .hero-founder {
        flex-direction: column;
        justify-content: center;
    }

    .founder-avatar {
        margin: 0 6rem 0;
    }

    .founder-description,
    .cto-founder .founder-description  {
        text-align: center;
        max-width: 90rem;
    }

    .main-side {
      text-align: center;
      max-width: 50rem;
      align-items: center;
      justify-content: center;
      display:flex;
      flex-direction: column;

    }
    .grid--2-cols {
         grid-template-columns: 1fr;
    }

    .custom-text {
      padding-bottom:0;
    }

    .custom-course-img{
      max-width:35rem;
    }
           
    .heading-primary {
      font-size: 3.6rem;
    }

    .heading-secondary {
      margin-bottom: 1rem;
    }
    /*
    .heading-course-cat {
      margin-bottom: 2.8rem;
    }*/

    .container{
      max-width: 100%;
      padding: 0;
    }

    .main-section{
      padding-left: 0;
    }
  }
  
  /* **************************** */
  /* BELOW 800px (tablet) */
  /* **************************** */
  @media (max-width: 50em) {
  }
  
  /* **************************** */
  /* BELOW 592px (mobile) */
  /* **************************** */
  @media (max-width: 37em) {
    .course-desc-cont{
      flex-grow: 0;
    }
    .course-box{
      flex-direction:column;
    }
    .heading-primary {
      font-size: 3rem;
    }

    .founder-heading {
        font-size: 2rem;
    }

    .founder-avatar .p-avatar {
        width: 15rem;
        height: 15rem;
    }

    .founder-description {
        padding: 1.2rem;
        font-size: 1.8rem;
        border-radius: 10px;
    }

    .main-side {
      font-size: 3rem;
      margin-left: 0;
    }
  }
  
  /* **************************** */
  /* BELOW 496px (mobile) */
  /* **************************** */
  @media (max-width: 31em) {
    .heading-primary {
      font-size: 2.4rem;
    }

    .heading-secondary {
      margin-bottom: 1rem;
    }

     button {
      padding: 8px 16px;
    }
  }

  /*** Grid */

  ::v-deep(.grid) {
    display: flex !important;
    flex-wrap: wrap;
    margin-left: -.5rem;
    margin-right: -.5rem;
    margin-top: -.5rem;
    column-gap: unset;
    row-gap: 4rem;
}

::v-deep(.grid>.col,.grid>[class*=col]) {
    box-sizing: border-box
}

::v-deep(.grid-nogutter) {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0
}

::v-deep(.grid-nogutter>.col,.grid-nogutter>[class*=col-]) {
    padding: 0
}

::v-deep(.p2){
  padding: .5rem !important;
}

::v-deep(.col) {
    flex-basis: 0;
    flex-grow: 1;
    padding: .5rem
}

::v-deep(.col-1,.col-fixed) {
    flex: 0 0 auto;
    padding: .5rem
}

::v-deep(.col-1) {
    width: 8.3333%
}

::v-deep(.col-2) {
    width: 16.6667%
}

::v-deep(.col-2,.col-3) {
    flex: 0 0 auto;
    padding: .5rem
}

::v-deep(.col-3) {
    width: 25%
}

::v-deep(.col-4) {
    width: 33.3333%
}

.col-4,.col-5 {
    flex: 0 0 auto;
    padding: .5rem
}

.col-5 {
    width: 41.6667%
}

.col-6 {
    width: 50%
}

.col-6,.col-7 {
    flex: 0 0 auto;
    padding: .5rem
}

.col-7 {
    width: 58.3333%
}

.col-8 {
    width: 66.6667%
}

.col-8,.col-9 {
    flex: 0 0 auto;
    padding: .5rem
}

.col-9 {
    width: 75%
}

.col-10 {
    width: 83.3333%
}

.col-10,.col-11 {
    flex: 0 0 auto;
    padding: .5rem
}

.col-11 {
    width: 91.6667%
}

::v-deep(.col-12) {
    flex: 0 0 auto;
    padding: .5rem;
    width: 100%
}

@media screen and (min-width: 576px) {
    .sm\:col {
        flex-basis:0;
        flex-grow: 1;
        padding: .5rem
    }

    .sm\:col-1,.sm\:col-fixed {
        flex: 0 0 auto;
        padding: .5rem
    }

    .sm\:col-1 {
        width: 8.3333%
    }

    .sm\:col-2 {
        width: 16.6667%
    }

    .sm\:col-2,.sm\:col-3 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .sm\:col-3 {
        width: 25%
    }

    .sm\:col-4 {
        width: 33.3333%
    }

    .sm\:col-4,.sm\:col-5 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .sm\:col-5 {
        width: 41.6667%
    }

    ::v-deep(.sm\:col-6) {
        width: 50%
    }

    ::v-deep(.sm\:col-6,.sm\:col-7) {
        flex: 0 0 auto;
        padding: .5rem
    }

    .sm\:col-7 {
        width: 58.3333%
    }

    .sm\:col-8 {
        width: 66.6667%
    }

    .sm\:col-8,.sm\:col-9 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .sm\:col-9 {
        width: 75%
    }

    .sm\:col-10 {
        width: 83.3333%
    }

    .sm\:col-10,.sm\:col-11 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .sm\:col-11 {
        width: 91.6667%
    }

    .sm\:col-12 {
        flex: 0 0 auto;
        padding: .5rem;
        width: 100%
    }
}

@media screen and (min-width: 768px) {
    .md\:col {
        flex-basis:0;
        flex-grow: 1;
        padding: .5rem
    }

    .md\:col-1,.md\:col-fixed {
        flex: 0 0 auto;
        padding: .5rem
    }

    .md\:col-1 {
        width: 8.3333%
    }

    .md\:col-2 {
        width: 16.6667%
    }

    .md\:col-2,.md\:col-3 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .md\:col-3 {
        width: 25%
    }

    ::v-deep(.md\:col-4) {
        width: 33.3333%
    }

    ::v-deep(.md\:col-4,.md\:col-5 ){
        flex: 0 0 auto;
        padding: .5rem
    }

    .md\:col-5 {
        width: 41.6667%
    }

    .md\:col-6 {
        width: 50%
    }

    .md\:col-6,.md\:col-7 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .md\:col-7 {
        width: 58.3333%
    }

    .md\:col-8 {
        width: 66.6667%
    }

    .md\:col-8,.md\:col-9 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .md\:col-9 {
        width: 75%
    }

    .md\:col-10 {
        width: 83.3333%
    }

    .md\:col-10,.md\:col-11 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .md\:col-11 {
        width: 91.6667%
    }

    .md\:col-12 {
        flex: 0 0 auto;
        padding: .5rem;
        width: 100%
    }
}

@media screen and (min-width: 992px) {
    .lg\:col {
        flex-basis:0;
        flex-grow: 1;
        padding: .5rem
    }

    .lg\:col-1,.lg\:col-fixed {
        flex: 0 0 auto;
        padding: .5rem
    }

    .lg\:col-1 {
        width: 8.3333%
    }

    .lg\:col-2 {
        width: 16.6667%
    }

    .lg\:col-2,.lg\:col-3 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .lg\:col-3 {
        width: 25%
    }

    .lg\:col-4 {
        width: 33.3333%
    }

    .lg\:col-4,.lg\:col-5 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .lg\:col-5 {
        width: 41.6667%
    }

    .lg\:col-6 {
        width: 50%
    }

    .lg\:col-6,.lg\:col-7 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .lg\:col-7 {
        width: 58.3333%
    }

    .lg\:col-8 {
        width: 66.6667%
    }

    .lg\:col-8,.lg\:col-9 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .lg\:col-9 {
        width: 75%
    }

    .lg\:col-10 {
        width: 83.3333%
    }

    .lg\:col-10,.lg\:col-11 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .lg\:col-11 {
        width: 91.6667%
    }

    .lg\:col-12 {
        flex: 0 0 auto;
        padding: .5rem;
        width: 100%
    }
}

@media screen and (min-width: 1200px) {
    ::v-deep(.xl\:col) {
        flex-basis:0;
        flex-grow: 1;
        padding: .5rem
    }

    .xl\:col-1,.xl\:col-fixed {
        flex: 0 0 auto;
        padding: .5rem
    }

    .xl\:col-1 {
        width: 8.3333%
    }

    .xl\:col-2 {
        width: 16.6667%
    }

    .xl\:col-2,.xl\:col-3 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .xl\:col-3 {
        width: 25%
    }

    .xl\:col-4 {
        width: 33.3333%
    }

    .xl\:col-4,.xl\:col-5 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .xl\:col-5 {
        width: 41.6667%
    }

    .xl\:col-6 {
        width: 50%
    }

    .xl\:col-6,.xl\:col-7 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .xl\:col-7 {
        width: 58.3333%
    }

    .xl\:col-8 {
        width: 66.6667%
    }

    .xl\:col-8,.xl\:col-9 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .xl\:col-9 {
        width: 75%
    }

    .xl\:col-10 {
        width: 83.3333%
    }

    .xl\:col-10,.xl\:col-11 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .xl\:col-11 {
        width: 91.6667%
    }

    .xl\:col-12 {
        flex: 0 0 auto;
        padding: .5rem;
        width: 100%
    }
}

.col-offset-0 {
    margin-left: 0!important
}

.col-offset-1 {
    margin-left: 8.3333%!important
}

.col-offset-2 {
    margin-left: 16.6667%!important
}

.col-offset-3 {
    margin-left: 25%!important
}

.col-offset-4 {
    margin-left: 33.3333%!important
}

.col-offset-5 {
    margin-left: 41.6667%!important
}

.col-offset-6 {
    margin-left: 50%!important
}

.col-offset-7 {
    margin-left: 58.3333%!important
}

.col-offset-8 {
    margin-left: 66.6667%!important
}

.col-offset-9 {
    margin-left: 75%!important
}

.col-offset-10 {
    margin-left: 83.3333%!important
}

.col-offset-11 {
    margin-left: 91.6667%!important
}

.col-offset-12 {
    margin-left: 100%!important
}

@media screen and (min-width: 576px) {
    .sm\:col-offset-0 {
        margin-left:0!important
    }

    .sm\:col-offset-1 {
        margin-left: 8.3333%!important
    }

    .sm\:col-offset-2 {
        margin-left: 16.6667%!important
    }

    .sm\:col-offset-3 {
        margin-left: 25%!important
    }

    .sm\:col-offset-4 {
        margin-left: 33.3333%!important
    }

    .sm\:col-offset-5 {
        margin-left: 41.6667%!important
    }

    .sm\:col-offset-6 {
        margin-left: 50%!important
    }

    .sm\:col-offset-7 {
        margin-left: 58.3333%!important
    }

    .sm\:col-offset-8 {
        margin-left: 66.6667%!important
    }

    .sm\:col-offset-9 {
        margin-left: 75%!important
    }

    .sm\:col-offset-10 {
        margin-left: 83.3333%!important
    }

    .sm\:col-offset-11 {
        margin-left: 91.6667%!important
    }

    .sm\:col-offset-12 {
        margin-left: 100%!important
    }
}

@media screen and (min-width: 768px) {
    .md\:col-offset-0 {
        margin-left:0!important
    }

    .md\:col-offset-1 {
        margin-left: 8.3333%!important
    }

    .md\:col-offset-2 {
        margin-left: 16.6667%!important
    }

    .md\:col-offset-3 {
        margin-left: 25%!important
    }

    .md\:col-offset-4 {
        margin-left: 33.3333%!important
    }

    .md\:col-offset-5 {
        margin-left: 41.6667%!important
    }

    .md\:col-offset-6 {
        margin-left: 50%!important
    }

    .md\:col-offset-7 {
        margin-left: 58.3333%!important
    }

    .md\:col-offset-8 {
        margin-left: 66.6667%!important
    }

    .md\:col-offset-9 {
        margin-left: 75%!important
    }

    .md\:col-offset-10 {
        margin-left: 83.3333%!important
    }

    .md\:col-offset-11 {
        margin-left: 91.6667%!important
    }

    .md\:col-offset-12 {
        margin-left: 100%!important
    }
}

@media screen and (min-width: 992px) {
    .lg\:col-offset-0 {
        margin-left:0!important
    }

    .lg\:col-offset-1 {
        margin-left: 8.3333%!important
    }

    .lg\:col-offset-2 {
        margin-left: 16.6667%!important
    }

    .lg\:col-offset-3 {
        margin-left: 25%!important
    }

    .lg\:col-offset-4 {
        margin-left: 33.3333%!important
    }

    .lg\:col-offset-5 {
        margin-left: 41.6667%!important
    }

    .lg\:col-offset-6 {
        margin-left: 50%!important
    }

    .lg\:col-offset-7 {
        margin-left: 58.3333%!important
    }

    .lg\:col-offset-8 {
        margin-left: 66.6667%!important
    }

    .lg\:col-offset-9 {
        margin-left: 75%!important
    }

    .lg\:col-offset-10 {
        margin-left: 83.3333%!important
    }

    .lg\:col-offset-11 {
        margin-left: 91.6667%!important
    }

    .lg\:col-offset-12 {
        margin-left: 100%!important
    }
}

@media screen and (min-width: 1200px) {
    .xl\:col-offset-0 {
        margin-left:0!important
    }

    .xl\:col-offset-1 {
        margin-left: 8.3333%!important
    }

    .xl\:col-offset-2 {
        margin-left: 16.6667%!important
    }

    .xl\:col-offset-3 {
        margin-left: 25%!important
    }

    .xl\:col-offset-4 {
        margin-left: 33.3333%!important
    }

    .xl\:col-offset-5 {
        margin-left: 41.6667%!important
    }

    .xl\:col-offset-6 {
        margin-left: 50%!important
    }

    .xl\:col-offset-7 {
        margin-left: 58.3333%!important
    }

    .xl\:col-offset-8 {
        margin-left: 66.6667%!important
    }

    .xl\:col-offset-9 {
        margin-left: 75%!important
    }

    .xl\:col-offset-10 {
        margin-left: 83.3333%!important
    }

    .xl\:col-offset-11 {
        margin-left: 91.6667%!important
    }

    .xl\:col-offset-12 {
        margin-left: 100%!important
    }
}
.relative {
    position: relative !important;
}
.mx-auto {
    /*margin-left: auto !important; */
    /* margin-right: auto !important; */
}
  </style>
  